import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import { ApolloProvider } from '@apollo/react-hooks';
import * as serviceWorker from './serviceWorker';
import * as Sentry from '@sentry/browser';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { store } from './stores';
import { apolloClient } from './utils/apollo';
import i18n from './translations/i18next';
import App from './App';
import moment from 'moment-timezone';

import './styles/main.scss';

moment.tz.setDefault(process.env.REACT_APP_DEFAULT_TIMEZONE || 'Europe/Prague');

library.add(fas, far);

if (process.env.REACT_APP_SENTRY_ENABLED === 'true') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    beforeSend: (event: Sentry.Event) => {
      // tslint:disable-next-line:no-console
      console.error(event);
      return event;
    },
  });
}

const client = apolloClient();

ReactDOM.render(
  <React.Fragment>
    <ApolloProvider client={client}>
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <Router>
            <App />
          </Router>
        </I18nextProvider>
      </Provider>
    </ApolloProvider>
  </React.Fragment>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
